import { useEffect } from 'react';
import { CheckoutState } from '../checkoutState';

const useEmmitState = (state: CheckoutState | undefined) => {
  useEffect(() => {
    if (!state) {
      return;
    }

    window.scayleCheckoutEvents.dispatchEvent(
      new CustomEvent<{
        state: CheckoutState;
      }>('state:updated', { detail: { state } })
    );
  }, [JSON.stringify(state)]);
}

export default useEmmitState;